























































import { Vue, Component } from "vue-property-decorator"
import Button from "../../../Button/index.vue";
import InfoIcon from "@/app/ui/assets/ics_f_icon_circle.vue";
import XCircle from "@/app/ui/assets/close_line.vue";
import AuthController from "@/app/ui/controllers/AuthController";
import Loading from "../../../Loading/index.vue";

@Component({
  components: {
    Button,
    InfoIcon,
    XCircle,
    Loading
  }
})
class MfaEnrollmentAlert extends Vue {
  get showMfaEnrollmentAlert(): boolean {
    return AuthController.showMfaEnrollmentAlert
  }

  get isLoadingProcess(): boolean {
    return AuthController.isLoading
  }

  onDismiss(): void {
    AuthController.dismissMfaEnrollmentAlert()
  }

  onActivate(): void {
    AuthController.navigateToMfaEnrollment()
  }
}

export default MfaEnrollmentAlert
